const EMBEDDED_BUILD_ID = process.env.VUE_APP_BUILD_ID || "";
const RELOAD_GUARD_KEY = "app_reload_build_id";

function isDevBuildId(buildId) {
  return !buildId || buildId.endsWith("-dev");
}

/**
 * If the server has a newer build than this bundle, reload once to pick up fresh assets.
 * Requires dist/version.json (production) and no-cache headers on index.html / version.json.
 */
export async function ensureLatestBuild() {
  if (typeof window === "undefined" || isDevBuildId(EMBEDDED_BUILD_ID)) {
    return;
  }

  try {
    const base = process.env.BASE_URL || "/";
    const root = base.endsWith("/") ? base : `${base}/`;
    const res = await fetch(`${root}version.json?t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return;

    const data = await res.json();
    const remoteBuildId = String(data?.buildId || "").trim();
    if (!remoteBuildId || remoteBuildId === EMBEDDED_BUILD_ID) return;

    const lastReloadFor = sessionStorage.getItem(RELOAD_GUARD_KEY);
    if (lastReloadFor === remoteBuildId) return;

    sessionStorage.setItem(RELOAD_GUARD_KEY, remoteBuildId);
    window.location.reload();
    await new Promise(() => {});
  } catch (_) {
    /* offline or version.json missing — keep running */
  }
}
